module.exports = __webpack_public_path__ + "static/img/empty_err.77c374b0.png";